// Contacts / Organisations / To-dos tab strip for the personal CRM pages, so
// each list is reachable from the others without going back to the dashboard.
import { NavLink } from 'react-router-dom'

const TABS = [
  { to: '/crm/contacts', label: 'Contacts' },
  { to: '/crm/organisations', label: 'Organisations' },
  { to: '/crm/todos', label: 'To-dos' },
]

export default function CrmTabs() {
  return (
    <nav aria-label="CRM sections" className="flex gap-1 border-b border-sky-200/50">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) =>
            `px-4 py-2 text-sm font-medium -mb-px border-b-2 ${
              isActive
                ? 'border-sky-500 text-sky-700'
                : 'border-transparent text-gray-600 hover:text-gray-900'
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  )
}
